import React, { useEffect } from 'react';
import _ from 'lodash';
import { translate } from '../../../Services/translation';
import { string, number, object } from 'yup';
import { post } from '../../../Services/http';
import { errorNoAction as errorReducer } from '../../../Reducers/Error.reducer';
import { setData, getData } from '../../../Services/LocalStorage.service';
import { DEFAULT_FORM_DATA } from '../../../Actions/Quotation.action';
import { connect } from 'react-redux';

const validationRules = object().shape({
    companyName: string().required(translate(`validation.required`)),
    firstName: string().required(translate(`validation.required`)),
    lastName: string().required(translate(`validation.required`)),
    contactPerson: string().required(translate(`validation.required`)),
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.email`)),
    phoneNumber: string().required(translate(`validation.required`)),
    address: string().required(translate(`validation.required`)),
    zipCode: string()
        .required()
        .matches(/^[0-9]+$/, translate(`validation.zipcode`)),
    city: string().required(translate(`validation.required`)),
    organizationNumber: null,
});

const QuotationForm = props => {
    const {
        formDetails,
        orderCarrier,
        response, // to-do
        termsUrl,
        errors,
        termsAccepted,
        submitState,

        // Functions/actions

        updateFormDetails,
        updateResponse,
        clearCart,

        setSubmitState,
        setTermsAcceptState,
        setErrorState,
    } = props;

    const formDetailsKey = 'quotationFormDetails';
    const articleNumbersList = getData('articleNumbersList');
    const model = props.payload.quotationModel;

    useEffect(() => {
        if (model.isLoggedIn) {
            prefillInputs(model);
        }
    }, []);

    const prefillInputs = model => {
        const formDetails = getData('quotationFormDetails', {});

        const newFormDataList = {
            companyName: formDetails.companyName || model.companyName,
            organizationNumber:
                formDetails.organizationNumber || model.organizationNumber,
            firstName: formDetails.firstName || model.customerDetails.firstName,
            lastName: formDetails.lastName || model.customerDetails.lastName,
            email: formDetails.email || model.customerDetails.email,
            phoneNumber:
                formDetails.phoneNumber || model.customerDetails.phoneNumber,
            country: formDetails.country || model.country,
            address: formDetails.address || model.customerDetails.address,
            zipCode: formDetails.zipCode || model.customerDetails.zipCode,
            city: formDetails.city || model.customerDetails.city,
            contactPerson:
                formDetails.contactPerson ||
                model.customerDetails.firstName +
                    ' ' +
                    model.customerDetails.lastName,
        };

        updateFormDetails(newFormDataList);
    };

    /**
     * On input/textarea change
     *
     * @param {any} e
     */
    const onInputChange = e => {
        let newData = {
            ...formDetails,
            ...{ [e.target.name]: e.target.value },
        };

        console.log(newData);

        updateFormDetails(newData);
        setData(formDetailsKey, newData);
    };

    /*
     * Stuff todo on submit, validation etc.
     *
     * @return {void}
     */
    const onSubmit = () => {
        let errorList = {};

        if (submitState) {
            return;
        }

        if (!termsAccepted) {
            errorList = {
                ...errorList,
                ...{
                    termsAccepted: [
                        translate('quotation.terms.validationerror'),
                    ],
                },
            };
        }

        validationRules
            .validate(formDetails, {
                abortEarly: false,
            })
            .then(async () => {
                if (Object.keys(errorList).length) {
                    setErrorState(errorList);
                    return;
                }

                let result = await sendQuotation();
                if (result.mailSent) {
                    resetForm(result);
                }
            })
            .catch(error => {
                setErrorState({ ...errorList, ...errorReducer(error) });
            });
    };

    /**
     * Send quotation, clear form on success etc.
     */
    const sendQuotation = () => {
        let payload = {
            articleNumbers: articleNumbersList,
            formDetails: formDetails,
            orderCarrier: orderCarrier,
        };

        setSubmitState(true);

        return post(`/casallpro/api/checkout/send`, payload)
            .then(response => response.json())
            .then(response => {
                payload.response = response;
                clearCart(payload);
                return response;
            })
            .catch(error => {
                /**
                 * @type {Promise}
                 */
                let promise = error.response.json();

                promise.then(response => {
                    updateResponse({
                        submitState: false,
                        response: {
                            message: response.message,
                            mailSent: false,
                        },
                    });
                });
            });
    };

    /**
     * Input field "template" function
     *
     * @param {string} id
     * @param {?string} placeholder
     * @param {string} type
     * @param {containerClass} containerClass
     * @param {options} options
     */
    const input = (
        id,
        placeholder = null,
        type,
        containerClass = '',
        options = {},
    ) => {
        let className = `quotation-form__col ${containerClass}`.trim();

        const hasMultipleOptions = options && Object.keys(options).length > 1;

        if (type === 'select' && !hasMultipleOptions) {
            return null;
        }

        return (
            <div className={className}>
                <label htmlFor={id}>
                    {translate(`quotation.form.${id.toLowerCase()}.label`)}
                </label>
                {type === 'select' && hasMultipleOptions ? (
                    <select
                        id={id}
                        name={id}
                        value={formDetails[id] || ''}
                        onChange={onInputChange}
                        className="quotation-form__input"
                    >
                        <option value="" disabled>
                            {placeholder ||
                                translate('quotation.form.select.placeholder')}
                        </option>
                        {Object.entries(options).map(([key, value]) => (
                            <option key={key} value={key}>
                                {value}
                            </option>
                        ))}
                    </select>
                ) : (
                    <input
                        id={id}
                        name={id}
                        value={formDetails[id] || ''}
                        placeholder={placeholder}
                        type={type}
                        onChange={onInputChange}
                        className="quotation-form__input"
                    />
                )}
                {errors[id] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors[id][0]}
                    </span>
                )}
            </div>
        );
    };

    /**
     * Clean form
     *
     * @return void
     */
    const resetForm = response => {
        localStorage.removeItem('products');
        localStorage.removeItem(formDetailsKey);

        updateResponse({
            count: 0,
            response: response,
            formDetails: DEFAULT_FORM_DATA,
            termsAccepted: false,
            submitState: false,
            listOfProducts: [],
        });

        window.scroll(0, 0);
    };

    return response.mailSent ? (
        <div className={'quotation-form__response'}>{response.message}</div>
    ) : (
        <div className="quotation-form__container">
            {articleNumbersList.length > 0 && !response.mailSent ? (
                <>
                    <div className="quotation-form__row">
                        <h3 className="h2 quotation-form__section-title">
                            {translate('quotation.list.heading')}
                        </h3>
                    </div>
                </>
            ) : (
                <div className={'quotation-form__generic-message'}>
                    {translate('quotation.emptynotice')}
                </div>
            )}

            {articleNumbersList.length > 0 && (
                <>
                    <div className="quotation-form__row">
                        <h3 className="h2 quotation-form__section-title-sub">
                            {translate('quotation.form.heading')}
                        </h3>
                    </div>

                    <div className="quotation-form__form quotation-form__row">
                        <div className="quotation-form__col quotation-form__col@lg-6">
                            <div className="quotation-form__row">
                                {input('companyName', null, 'text')}
                                {input('organizationNumber', null, 'text')}
                                {input(
                                    'firstName',
                                    null,
                                    'text',
                                    'quotation-form__col@lg-6',
                                )}
                                {input(
                                    'lastName',
                                    null,
                                    'text',
                                    'quotation-form__col@lg-6',
                                )}
                                {input('email', null, 'email')}
                                {input('phoneNumber', null, 'tel')}
                                {input(
                                    'country',
                                    null,
                                    'select',
                                    '',
                                    model.countryOptions,
                                )}

                                <div className="quotation-form__address-container">
                                    <div className="quotation-form__col">
                                        <h4>
                                            {translate(
                                                'quotation.form.address.heading',
                                            )}
                                        </h4>
                                    </div>

                                    {input('address', null, 'text')}
                                    {input(
                                        'zipCode',
                                        null,
                                        'text',
                                        'quotation-form__col@md-6',
                                    )}
                                    {input(
                                        'city',
                                        null,
                                        'text',
                                        'quotation-form__col@md-6',
                                    )}
                                </div>

                                {input(
                                    'contactPerson',
                                    null,
                                    'text',
                                    'quotation-form__col@lg-6',
                                )}
                            </div>
                        </div>

                        <div className="quotation-form__col">
                            <div className="quotation-form__terms">
                                <input
                                    type="checkbox"
                                    id="termsAccepted"
                                    className="quotation-form__terms_checkbox"
                                    onChange={() => {
                                        setTermsAcceptState(!termsAccepted);
                                    }}
                                    checked={termsAccepted}
                                />
                                <label
                                    htmlFor="termsAccepted"
                                    className="psuedo-checkbox"
                                ></label>
                                <label
                                    htmlFor="termsAccepted"
                                    className="quotation-form__terms_label"
                                >
                                    {translate('quotation.terms.label')}{' '}
                                    <a
                                        href={termsUrl}
                                        target="_blank"
                                        rel="nofollow"
                                    >
                                        {translate('quotation.terms.linktext')}
                                    </a>
                                </label>
                                {errors.termsAccepted && (
                                    <span className="form__validator--error form__validator--top-narrow">
                                        {errors.termsAccepted[0]}
                                    </span>
                                )}
                            </div>
                            <button
                                type="submit"
                                onClick={onSubmit}
                                className={
                                    'quotation-form__submit ' +
                                    (submitState ? 'is-animating' : '')
                                }
                            >
                                {translate('quotation.form.submit.text')}
                            </button>

                            {!response.mailSent && response.message !== '' && (
                                <div
                                    className={
                                        'quotation-form__generic-message'
                                    }
                                >
                                    {response.message}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const mapStateToProps = state => {
    const { checkout, quotation } = state;
    return {
        ...checkout,
        ...quotation,
    };
};

export default connect(mapStateToProps, null)(QuotationForm);
